import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  loading: false,
  role: "",
};

const userReq = createAction("userByIdRequest");
const userSuccess = createAction("userByIdSuccess");
const userFail = createAction("userByIdFailure");

const authencationState = createAction("authenticationState");

const clear = createAction("clearUserData");

export const userReducer = createReducer(initialState, (builder) => {
  builder
    // User by Id
    .addCase(userReq, (state, action) => {
      state.loading = true;
    })
    .addCase(userSuccess, (state, action) => {
      state.loading = false;
      state.userData = action.payload?.user;
    })
    .addCase(userFail, (state, action) => {
      state.loading = false;
    })

    // Authentication State
    .addCase(authencationState, (state, action) => {
      state.isAuthenticated = action.payload;
    })

    // Clear User Data
    .addCase(clear, (state, action) => {
      state.userData = null;
      state.isAuthenticated = false;
      state.loading = false;
    });
});
